import ApiHandler from "./ApiHandler";

const Invitation = {
  getMy: async (query) => await ApiHandler.i.auth().get(`/invitation/my?${query.toString()}`),
  postPrepare: async (data, options) => await ApiHandler.i.auth().post('/invitation/prepare', data, options),
  putViewed: async (invitationId) => await ApiHandler.i.auth().put(`/invitation/${invitationId}/viewed`, {}),
};

export default Invitation;